// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().name("world_id"),
  villageId: __t.u64().name("village_id"),
  spot: __t.u8(),
  owner: __t.identity(),
  kind: __t.u8(),
  heroId: __t.u64().name("hero_id"),
  x: __t.f32(),
  y: __t.f32(),
  seed: __t.u32(),
  at: __t.timestamp(),
});
